import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Schlanke Bruecke zwischen der Tour-Step-Config (plain TypeScript, kein
 * DI-Kontext) und der `EmployeeListComponent`. Ermoeglicht der Mitarbeiter-
 * Seiten-Tour (`EMPLOYEE_LIST_HELP_TOUR`), das 3-Punkte-Lehr-Panel
 * (Actions-Showcase) ein- und auszublenden.
 *
 * Warum ein Lehr-Panel statt des echten `mat-menu`: das echte Menue ist
 * permissions-/rollen-konditional (z. B. "Berechtigungen verwalten" erscheint
 * nur bei `Role === 3`) und lebt in einem CDK-Overlay mit eigenem Backdrop/
 * Z-Index — fuer ein Lehr-Highlighting von oben nach unten unzuverlaessig.
 * Das Showcase-Panel ist ein normales in-page Element: der Spotlight schneidet
 * es frei, die Voice-Over-Cues pulsen jeden Eintrag verlaesslich, und es zeigt
 * IMMER alle Aktionen (die rollen-abhaengige Sichtbarkeit wird im Voice-Over
 * erwaehnt).
 *
 * Verwendung in der Tour-Config:
 *   onBeforeShow: () => employeeListTourBridge.showActionsShowcase(),
 *   onAfterHide:  () => employeeListTourBridge.hideActionsShowcase(),
 *
 * Die Komponente abonniert `showcaseVisible$()` (async-Pipe im Template) und
 * rendert das Panel via `*ngIf`.
 */
const _showcase$ = new BehaviorSubject<boolean>(false);

export const employeeListTourBridge = {
  /** Beobachtbar: ob das 3-Punkte-Lehr-Panel gerade sichtbar sein soll. */
  showcaseVisible$: (): Observable<boolean> => _showcase$.asObservable(),

  /** Blendet das Lehr-Panel ein (Tour-Step `row-menu`, onBeforeShow). */
  showActionsShowcase: (): void => _showcase$.next(true),

  /** Blendet das Lehr-Panel wieder aus (Step-Ende / Tour-Abbruch). */
  hideActionsShowcase: (): void => _showcase$.next(false),

  /** Synchroner Snapshot (z. B. fuer skipIf-Closures). */
  isShowcaseVisible: (): boolean => _showcase$.value,
};
